import { useMemo } from "react";
import parse from "html-react-parser";

// Components
import Section from "../../../components/Section/SectionContainer";

// CSS
import styles from "../conference.module.scss";

export const ConferenceDescription = (props) => {
    const { conference } = props;
    const { description, is_active, logo } = conference || {};

    const descriptionArray = useMemo(
        () => description?.match(/[^\r\n]+/g),
        [description]
    );

    /*function renderDescription() {
        return descriptionArray?.map((line, i) => {
            return <p key={i}>{line}</p>;
        });
    }
    */

    return is_active ? (
        <Section classes={styles.conferenceDescription}>
            {logo && (
                <img
                    src={logo?.sizes?.thumbnail}
                    alt="Conference logo"
                    className={styles.logo}
                />
            )}

            <span className={styles.description}>
                {description && <span>{parse(conference.description)}</span>}
            </span>
            {/*{renderDescription()}*/}
        </Section>
    ) : null;
};
